import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import xclose from "../../assets/icons/x-close.svg";
import backArrowPage from "../../assets/icons/backArrowPage.svg";
import BuildingIcon from "../../assets/icons/Building.svg";
import DocSearchIcon from "../../assets/icons/DocSearch.svg";
import SettingNoteIcon from "../../assets/icons/SettingNote.svg";
import ConfirmAlertModal from "../common/confirmAlertModal";
import Alert from "../common/Alert";
import Loader from "../../assets/loader.gif";
import _ from "lodash";
import WariningAlertModal from "../common/WariningAlertModal";
import axios from "axios";
import {
  deleteFile,
  downloadFile,
  getFileNames,
  getPresignedUrl,
  uploadFileToS3,
  getTimelineData,
} from "../../services/timeline-service";
import { getDiscount } from "../../services/discount-services";
import OrderBookingTab from "./Orderbooking";
import DiscountAdd from "../Masters/EnquiryMaster/DiscountAdd";
import AddTimelineMaster from "../Masters/EnquiryMaster/AddTimelineMaster";

import editIcon from "../../assets/icons/EditIcon.svg";
import pdfIcon from "../../assets/icons/pdf.svg";

import generateIsobPdf from "../../utils/generateIsobPdf";
import { getMasterData, getSharepointList } from "../../services/enquiryMaster-service";
import { getSalesUser } from "../../services/discount-services";
import {
  getOBAmendmentData,
  getOBKitAttachmentData,
  addOrderBookingData,
  addIsobData,
  addIsobBpData,
  addIsobCompData,
  addIsobDwgData,
  addIsobPgCommercialData,
  addIsobLdData,
  addIsobAdvanceData,
  addIsobDealerSacData,
  addIsobMiscData,
  rollbackOrderBooking,
  rollbackIsobData,
  updateIsob,
  downloadOrderBookingPdf,
  updateOrderBookingData,
} from "../../services/orderBooking-service";

import AddIsob from "../Isob/AddIsob";
import AmendmentHistory from "./AmendmentHistory";
import { formatAmountLabel, validINRCurrency } from "../../helpers/formatter";
import { getIsobPgCommercialData } from "../../services/isob-service";

export default function AddOrderBooking(props) {
  console.log("props for orderbooking", props);
  console.log("props.rowdataaaaaaaaaaaa", props.rowdata);
  console.log("props.enquirydata", props.enquiryData);

  const EnquiryID = props.enquiryData?.ID || Number(props.rowdata?.Title) || "";

  const formName = "Order Booking";
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [waringMessage, setWaringMessage] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showDiscountAdd, setShowDiscountAdd] = useState(false);
  const [showTimelineMaster, setShowTimelineMaster] = useState(false);
  const [action, setAction] = useState(props.action);
  const [file, setFile] = useState([]);
  const [obj, setObj] = useState([]);
  const [error, setError] = useState({});
  const [fileNames, setFileNames] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [kitAttachmentData, setKitAttachmentData] = useState([]);
  const [amendmentData, setAmendmentData] = useState([]);
  const [showIsob, setShowIsob] = useState(false);
  const [timelineRecord, setTimelineRecord] = useState({});
  const [discountRecord, setDiscountRecord] = useState({});
  const timelineRecordRef = useRef(timelineRecord);
  const discountRecordRef = useRef(discountRecord);
  const [showTimelineView, setShowTimelineView] = useState(false);
  const [showDiscountView, setShowDiscountView] = useState(false);
  const [isobData, setIsobData] = useState(null);
  const [isobFormValues, setIsobFormValues] = useState({});
  const [showAmendment, setShowAmendment] = useState(false);
  const [deletedOldFiles, setDeletedOldFiles] = useState({ commercial: [], technical: [] });
  const [resetKey, setResetKey] = useState(0);
  const [salespersonId, setSalespersonId] = useState(null);
  const [salesperson, setSalesperson] = useState({ id: null, name: "" });
  const [showIsobPdfIcon, setShowIsobPdfIcon] = useState(false);
  const [newRemark, setNewRemark] = useState("");

  const getInitialData = () => {
    const data = props.rowdata ? { ...props.rowdata } : {};
    if (props.enquiryData && !props.rowdata?.ID) {
      const enquiry = props.enquiryData;
      if (enquiry.SSGTerritory) data.Branch = enquiry.SSGTerritory;
      if (enquiry.ChannelType) data.ChannelType = enquiry.ChannelType;
      if (enquiry.PG) data.PG = enquiry.PG.results || enquiry.PG;
      if (enquiry.OrderType || enquiry.EnquiryType)
        data.OrderType = enquiry.OrderType || enquiry.EnquiryType;
      if (enquiry.ScopeOfInstallation)
        data.ScopeOfInstallation = enquiry.ScopeOfInstallation;
      if (enquiry.Plant) data.Plant = enquiry.Plant;
      if (enquiry.Routing) data.Routing = enquiry.Routing;
      if (enquiry.Sitelocation) data.Sitelocation = enquiry.Sitelocation;
      if (enquiry.Service_Category)
        data.Service_Category = enquiry.Service_Category;
      if (enquiry.OrderValueLakhs)
        data.OrderValueLakhs = enquiry.OrderValueLakhs;
    }
    return data;
  };

  const [formValues, setFormValues] = useState(() => {
    return props.rowdata ? { ...props.rowdata } : { ChannelType: "Dealer" };
  });

//   const [formValues, setFormValues] = useState(() => {
//     const data = props.rowdata ? { ...props.rowdata } : {};
//     if (data.PG) data.PG = data.PG.results || (Array.isArray(data.PG) ? data.PG : []);
//     return data;
// });

  useEffect(() => {
    if (props.enquiryData && !props.rowdata?.ID) {
      const enquiry = props.enquiryData;
      setFormValues((prev) => ({
        ...prev,
        ...(enquiry.SSGTerritory && { Branch: enquiry.SSGTerritory }),
        ChannelType: enquiry.ChannelType || "Dealer",
        ...(enquiry.PG && { PG: enquiry.PG.results || enquiry.PG }),
        ...(enquiry.ScopeOfInstallation && {
          ScopeOfInstallation: enquiry.ScopeOfInstallation,
        }),
        ...(enquiry.Plant && { Plant: enquiry.Plant }),
        ...(enquiry.Routing && { Routing: enquiry.Routing }),
        ...(enquiry.Sitelocation && { Sitelocation: enquiry.Sitelocation }),
        ...(enquiry.Service_Category && {
          Service_Category: enquiry.Service_Category,
        }),
        ...(enquiry.OrderValueLakhs && {
          OrderValueLakhs: enquiry.OrderValueLakhs,
        }),
        ...(enquiry.OrderBookingType && {
          OrderBookingType: enquiry.OrderBookingType,
        }),
        ...(enquiry.ID && { ID: enquiry.ID }),
        ...(enquiry.AccountName && { CustomerName: enquiry.AccountName }),
        ...(enquiry.Government && { Government: enquiry.Government }),
        ISOB: prev.ISOB || "Pending",
        ISOBRev: prev.ISOBRev ?? 0.0,
      }));
    }
  }, [props.enquiryData]);

  console.log("formValues", formValues);

  const fetchData = async () => {
    setLoading(true);
    let latestTimeline = null;
    let latestDiscount = null;
    try {
      const masterValues = await getMasterData();
      setMasterData(
        masterValues.data.map((item) => ({
          title: item.Title,
          value: item.Value,
        })),
      );

      const isobPdfEntry = masterValues.data.find(
      (item) => item.Title === "Dealer ISOB PDF Download"
      );
      setShowIsobPdfIcon(isobPdfEntry?.Value?.trim().toLowerCase() === "yes");

      // Fetch timeline and discount data for this enquiry
      const enquiryId = String(
        props.enquiryData?.ID || props.rowdata?.Title || "",
      );
      console.log("myNewenquiryId", typeof enquiryId, enquiryId);
      if (enquiryId) {
        const [timelineRes, discountRes] = await Promise.all([
          getTimelineData().catch(() => ({ data: [] })),
          getDiscount().catch(() => ({ data: [] })),
        ]);
        console.log("timelineRes full", timelineRes);
        console.log("discountRes full", discountRes);
        const timelines = (timelineRes?.data || []).filter(
          (t) => String(t.Title).trim() === enquiryId.trim(),
        );
        const discounts = (discountRes?.searchdata?.data || []).filter(
          (d) => String(d.field_5) === enquiryId,
        );
        console.log("latestDiscount 1", discounts)
        latestTimeline = timelines.length > 0 ? timelines[0] : null;
        latestDiscount = discounts.length > 0 ? discounts[0] : null;
        console.log("latestTimeline", latestTimeline);
        console.log("latestDiscount", latestDiscount);
        setTimelineRecord(latestTimeline);
        setDiscountRecord(latestDiscount);

        // Auto-set Attached if conditions are met
        if (!props.rowdata?.ID) {
        if (latestTimeline && latestTimeline.EnquiryStatus === "Closed") {
          const orderType = props.enquiryData?.OrderType || props.enquiryData?.EnquiryType || "";
          const isSwift = orderType.trim().toLowerCase() === "swift";
          if (!isSwift) setFormValues((prev) => ({ ...prev, PreOrderTimeline: "Attached" }));
        }
        if (
          latestDiscount &&
          latestDiscount.Approvalstatus?.trim() === "Approved"
        ) {
          setFormValues((prev) => ({ ...prev, DiscountSanction: "Attached" }));
        }
      }
      }

      if (props.rowdata?.ID) {
        let currentOrder = { order: props.rowdata.ID };
        const kitAttachmentValues = await getOBKitAttachmentData(currentOrder);
        console.log("kitAttachmentValues", kitAttachmentValues);

        if (kitAttachmentValues?.data?.length > 0) {
          const kit = kitAttachmentValues.data[0];
          setFormValues((prev) => ({
            ...prev,
            obKitAttachmentId: kit.ID,
            ISOBRev: kit.ISOBRevision ?? 0.0, 
            ...(kit.DesignApproval && {
              DrawingApprovalMail: kit.DesignApproval,
            }),
            ...(kit.BOM && { FinalDirectBookingBOM: kit.BOM }),
            ...(kit.LOI && { LOICustConfirmation: kit.LOI }),
            ...(kit.CustPO && { CustomerPO: kit.CustPO }),
            ...(kit.DealerPO && { DealerPO: kit.DealerPO }),
            ...(kit.DRAWING_x002f_LAYOUT && {
              DrawingLayout: kit.DRAWING_x002f_LAYOUT,
            }),
            ...(kit.PreOrderTimeline && kit.PreOrderTimeline !== "Not Applicable" && {
              PreOrderTimeline: kit.PreOrderTimeline,
            }),
            ...(kit.DiscountSanction && {
              DiscountSanction: kit.DiscountSanction,
            }),
            ...(kit.SITECHECKLIST && { SiteChecklist: kit.SITECHECKLIST }),
            ...(kit.SiteMeasurements && {
              SiteMeasurements: kit.SiteMeasurements,
            }),
            ...(kit.GST && { DeliveryGSTAddressProof: kit.GST }),
            ...(kit.TDSDECLARATION && { TDSDeclaration: kit.TDSDECLARATION }),
            ...(kit.PhysicalMaterialConfirmation && {
              PhyMaterialConfirmation: kit.PhysicalMaterialConfirmation,
            }),
            ...(kit.AdvanceReceipt && { AdvanceReceipt: kit.AdvanceReceipt }),
            ...(kit.ADDITIONALDOCUMENTS && {
              AdditionalDocs: kit.ADDITIONALDOCUMENTS,
            }),
            ...(kit.ISOB && { ISOB: kit.ISOB }),
            ...(latestTimeline?.EnquiryStatus === "Closed" && formValues.OrderType?.trim().toLowerCase() !== "swift" && { PreOrderTimeline: "Attached" }),
            ...(latestDiscount?.Approvalstatus?.trim() === "Approved" && { DiscountSanction: "Attached" }),
          }));
        }

         const pgCommRes = await getIsobPgCommercialData({
           obId: String(props.rowdata.ID)
         }).catch(() => ({ data: [] }));
         const latestFinalBasicPrice = pgCommRes.data?.[0]?.FinalBasicPrice;
         if (latestFinalBasicPrice != null) {
           setFormValues((prev) => ({
             ...prev,
             OrderValueLakhs: latestFinalBasicPrice,
           }));
         }
        const amendmentValues = await getOBAmendmentData(currentOrder);
        console.log("amendmentValues", amendmentValues);
        if (amendmentValues?.data) {
          setAmendmentData(amendmentValues.data);
        }
      }
    } catch (error) {
      console.error("error in catch", error);
    }
    setLoading(false);
  };

  console.log("newTimeline", timelineRecord);

  console.log("newDiscount", discountRecord);

  useEffect(() => {
    timelineRecordRef.current = timelineRecord;
  }, [timelineRecord]);

  useEffect(() => {
    discountRecordRef.current = discountRecord;
  }, [discountRecord]);

  useEffect(() => {
    fetchData();
    fetchSalespersonId();
  }, []);

  const fetchSalespersonId = async () => {
    try {
      const enquiryId = props.enquiryData?.ID || props.rowdata?.Title;
      if (!enquiryId) return;
      const [enquiryList, salesUsers] = await Promise.all([getSharepointList(), getSalesUser()]);
      const salesUsersList = salesUsers?.data || salesUsers || [];
      const obRecord = (enquiryList?.data || enquiryList || []).find(
        (r) => Number(r.ID) === Number(enquiryId)
      );
      const assignedToId = obRecord?.AssignedtoId;
      if (!assignedToId) return;
      setSalespersonId(assignedToId);
      const salesUser = salesUsersList.find((u) => Number(u.SalespersonId) === Number(assignedToId));
      setSalesperson({ id: assignedToId, name: salesUser?.field_1 || "" });
    } catch (err) {
      console.error("Error fetching salesperson id:", err);
    }
  };

  const [editSnapshot, setEditSnapshot] = useState(null);

  const resetForm = () => {
    if (action === "Edit" && editSnapshot) {
      setFormValues({ ...editSnapshot });
    } else {
      const enquiry = props.enquiryData || {};
      const readOnlyFields = {
        ...(enquiry.SSGTerritory && { Branch: enquiry.SSGTerritory }),
        ...(enquiry.PG && { PG: enquiry.PG.results || enquiry.PG }),
        ChannelType: enquiry.ChannelType || "Dealer",
      };
      setFormValues(props.rowdata?.ID ? { ...props.rowdata } : readOnlyFields);
    }
    setErrors({});
    setError({});
    setMandatoryFields([]);
    setFile([]);
    setObj([]);
    setNewRemark("");
    setDeletedOldFiles({ commercial: [], technical: [] });
    setResetKey((prev) => prev + 1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("name input", e);

    setFormValues((prevState) => {
      const updated = { ...prevState, [name]: value };
      if (
        name === "OrderType" &&
        value !== "Service" &&
        value !== "Service Swift"
      ) {
        updated.Service_Category = "";
      }
      if (name === "OrderType") {
        updated.PreOrderTimeline = value.trim().toLowerCase() === "swift" ? "Not Applicable" : "Pending";
      }
      return updated;
    });
  };

  console.log("masterdata", masterData);

  const getDropDownOptions = (title) => {
    console.log("title", title);

    return masterData
      .filter((Type) => Type.title === title)
      .flatMap((Type) => Type.value.split(","))
      .map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ));
  };

  const reasonForSubmissionMapping = {
    "ISOB/Document Submit":
      "For sending ISOB or documents before Project No. is generated.",
    "Revision: NonTechnical Change":
      "For sending pending docs after Project No. is generated.",
    "Revision: Technical Change [Order Amendment]":
      "For requesting technical change, considered as Order Amendment after Project No. is generated.",
  };

  const handleCloseConf = () => {
    setShow(false);
  };
  const handleCloseWarningConf = () => {
    setShowWarning(false);
  };

  const handleDiscountAdd = () => {
    setShowDiscountAdd(true);
  };

  const handleDiscountClose = () => {
    setShowDiscountAdd(false);
  };

  const handleClose = () => {
    resetForm();
    props.onHide();
  };

  const handleFileDownload = async (filename) => {
    try {
      setLoading(true);
      const response = await downloadFile(
        props.rowdata?.ID,
        filename,
        "orderBooking",
      );
      console.log("response in download", response);
      if (response.data && response.data.downloadUrl) {
        const fileResponse = await axios.get(response.data.downloadUrl, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(fileResponse.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        await handleFileDelete(response.data.fileKey);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      Alert("error", "Failed to download file");
    } finally {
      setLoading(false);
    }
  };

  async function getFilename(timelineId) {
    console.log("timelineid ", timelineId);

    try {
      let filenames = await getFileNames(Number(timelineId), "orderBooking");
      console.log("filename filename", filenames);

      setFileNames(filenames);
    } catch (error) {
      console.log("error", error);
    }
  }

  const handleFileDelete = async (fileKey) => {
    console.log("file key in orderbooking", fileKey);
    try {
      setLoading(true);
      await deleteFile(fileKey, "orderBooking");
      console.log("File deleted successfully");
      await getFilename(props.rowdata?.ID);
    } catch (error) {
      console.log("Failed to delete file");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeStatus = (files, fieldName) => {
    setLoading(true);
    const existingFiles = file[fieldName] || [];
    const existingFileNames = obj[fieldName] || [];
    const maxFiles = fieldName === "CommercialAttachments" ? 10 : 5;
    const newFiles = Array.from(files).slice(
      0,
      maxFiles - existingFiles.length,
    );

    // Check total size limit
    const existingSize = existingFiles.reduce(
      (sum, f) => sum + (f.size || 0),
      0,
    );
    const newSize = newFiles.reduce((sum, f) => sum + f.size, 0);
    const totalSize = existingSize + newSize;

    if (totalSize > commonFileUploadProps.maxTotalSize) {
      const errMsg = `Total file size cannot exceed ${(commonFileUploadProps.maxTotalSize / 1048576).toFixed(0)}MB. Current: ${(totalSize / 1048576).toFixed(2)}MB`;
      Alert("error", errMsg);
      setLoading(false);
      return;
    }

    const newFileNames = newFiles.map((f) => f.name);

    setFile((prev) => ({
      ...prev,
      [fieldName]: [...existingFiles, ...newFiles],
    }));
    setObj((prevState) => ({
      ...prevState,
      [fieldName]: [...existingFileNames, ...newFileNames],
    }));
    setLoading(false);
  };

  const handleDeleteDocument = (index, fieldName) => {
    setFile((prev) => {
      const updatedFiles = [...(prev[fieldName] || [])];
      updatedFiles.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedFiles,
      };
    });
    setObj((prev) => {
      const updatedNames = [...(prev[fieldName] || [])];
      updatedNames.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedNames,
      };
    });
  };

  let maxFileSize = 26214400;

  let acceptedExtensions = {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
    "application/vnd.ms-excel": [".xls"],
  };

  //     const getFileUploadProps = (fieldName) => ({
  //     maxSize: maxFileSize,
  //     acceptedExtensions: acceptedExtensions,
  //     maxFiles: fieldName === "CommercialAttachments" ? 10 : 5,
  //     isMultiple: true,
  //     maxTotalSize: 52428800
  // });

  const commonFileUploadProps = {
    maxSize: maxFileSize,
    acceptedExtensions: acceptedExtensions,
    maxFiles: 10,
    isMultiple: true,
    maxTotalSize: 26214400,
  };

  const commonProps = {
    setObj: setObj,
    setError: setError,
    error: error,
    mandatoryFields: mandatoryFields,
    setMandatoryFields: setMandatoryFields,
  };

  const isServiceOrder =
    formValues.OrderType === "Service" ||
    formValues.OrderType === "Service Swift";

  const isFormValid =
    formValues.Branch &&
    formValues.Sitelocation &&
    formValues.Plant &&
    formValues.ChannelType &&
    formValues.Routing &&
    formValues.PG &&
    (Array.isArray(formValues.PG) ? formValues.PG.length > 0 : true) &&
    formValues.ScopeOfInstallation &&
    formValues.OrderType &&
    formValues.OrderBookingType &&
    (!isServiceOrder ||
      (formValues.Service_Category &&
        (Array.isArray(formValues.Service_Category)
          ? formValues.Service_Category.length > 0
          : true)));

  console.log("formvalues before handle addd", formValues);
  console.log("isob data before handle add", isobData);

  const uploadFiles = async (fileList, type, referenceId) => {
    const keys = [];
    for (const f of fileList) {
      const presignedResponse = await getPresignedUrl(f.name, f.size, referenceId, type === "commercial" ? "Commercial" : "Technical");
      const presignedData = JSON.parse(presignedResponse.data);
      await uploadFileToS3(presignedData.uploadUrl, f);
      keys.push(presignedData.Key);
    }
    return keys;
  };

  console.log("timelinerecordref",timelineRecordRef);

  const formatRemarkEntry = (comment) => {
    const now = new Date();
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const d = now.getDate(), mon = months[now.getMonth()], yr = String(now.getFullYear()).slice(2);
    const hh = String(now.getHours()).padStart(2,"0"), mm = String(now.getMinutes()).padStart(2,"0");
    return `<br>${d} ${mon} '${yr} ${hh}:${mm} (${salesperson.name || "User"}):    ${comment}`;
};

  const handleAdd = async () => {
    const isEdit = action === "Edit";

    if (!isEdit) {
      const isSwiftOrder = formValues.OrderType?.trim().toLowerCase() === "swift";
      const MANDATORY_CHECKLIST_FIELDS = [
        { field: "DrawingApprovalMail", label: "Drawing Approval Mail" },
        { field: "LOICustConfirmation", label: "LOI/Cust Confirmation" },
        { field: "DiscountSanction", label: "Discount Sanction" },
        ...(formValues.Routing === "Direct" ? [{ field: "FinalDirectBookingBOM", label: "Final Direct Booking BOM" }] : []),
        ...(formValues.ChannelType === "Dealer" ? [{ field: "DealerPO", label: "Dealer PO" }] : []),
        ...(!isSwiftOrder ? [{ field: "PreOrderTimeline", label: "Pre Order Timeline" }] : []),
      ];
      const firstPending = MANDATORY_CHECKLIST_FIELDS.find(
        ({ field }) => !formValues[field] || formValues[field] === "Pending"
      );
      if (firstPending) { Alert("error", `${firstPending.label} should be Attached`); return; }
      if (formValues.ISOB === "Pending" &&
        (formValues.ISOBRev === 0.0 || formValues.ISOBRev === "0.0")) { Alert("error", "ISOB Rev should be Attached"); return; }

      if (!isobData) { Alert("error", "Kindly fill ISOB Details"); return; }

      // if (!file.CommercialAttachments || file.CommercialAttachments.length === 0) {
      //   Alert("error", "Kindly select atleast one Commercial Attachments");
      //   return;
      // }

      //    if (
      //   formValues.ISOB === "Pending" &&
      //   (formValues.ISOBRev === 0.0 || formValues.ISOBRev === "0.0")
      // ) {
      //   Alert("error", "ISOB Rev 0.0 should be Attached");
      //   return;
      // }
    }

    setLoading(true);
    const insertedRecords = [];
    const updatedRecords = [];
    let obUpdated = false;
    let orderBookingId = isEdit ? formValues.ID : undefined;

    try {
      // 1. Delete old files (Edit only) — no rollback needed, these were already removed by user intent
      if (isEdit) {
        for (const filename of deletedOldFiles.commercial)
          await deleteFile(`orderBooking/${formValues.ID}/${filename}`, "orderBooking");
        for (const filename of deletedOldFiles.technical)
          await deleteFile(`obkit/${formValues.obKitAttachmentId}/${filename}`, "obkit");
      }

      // 2. Upload new files
      const referenceId = props.enquiryData?.ID || formValues.ID;
      const commercialFiles = file.CommercialAttachments?.length
        ? await uploadFiles(file.CommercialAttachments, "commercial", referenceId)
        : [];
      const technicalFiles = file.TechnicalAttachments?.length
        ? await uploadFiles(file.TechnicalAttachments, "technical", referenceId)
        : [];

      // 3. Shared OB checklist fields
      const obChecklistFields = {
        Branch: formValues.Branch || "",
        Sitelocation: formValues.Sitelocation || "",
        Plant: formValues.Plant || "",
        ChannelType: formValues.ChannelType || "",
        Routing: formValues.Routing || "",
        PG: Array.isArray(formValues.PG) ? formValues.PG : (formValues.PG?.results || []),
        ScopeOfInstallation: formValues.ScopeOfInstallation || "",
        OrderType: formValues.OrderType || "",
        Service_Category: formValues.Service_Category || "",
        OrderBookingType: formValues.OrderBookingType || "",
        remarks: newRemark.trim()
        ? (formValues.remarks || "") + formatRemarkEntry(newRemark.trim())
        : (formValues.remarks || ""),
        ISOB: formValues.ISOB || "Pending",
        DesignApproval: formValues.DrawingApprovalMail || "Pending",
        BOM: formValues.FinalDirectBookingBOM || "Pending",
        LOI: formValues.LOICustConfirmation || "Pending",
        CustPO: formValues.CustomerPO || "Pending",
        DealerPO: formValues.DealerPO || "Pending",
        DRAWING_x002f_LAYOUT: formValues.DrawingLayout || "Pending",
        PreOrderTimeline: formValues.PreOrderTimeline || "Pending",
        DiscountSanction: formValues.DiscountSanction || "Pending",
        SITECHECKLIST: formValues.SiteChecklist || "Pending",
        SiteMeasurements: formValues.SiteMeasurements || "Pending",
        GST: formValues.DeliveryGSTAddressProof || "Pending",
        TDSDECLARATION: formValues.TDSDeclaration || "Pending",
        PhysicalMaterialConfirmation: formValues.PhyMaterialConfirmation || "Pending",
        AdvanceReceipt: formValues.AdvanceReceipt || "Pending",
        ADDITIONALDOCUMENTS: formValues.AdditionalDocs || "Pending",
        Government: formValues.Government,
        CustomerName: formValues.CustomerName || "",
        ISOBRevision: formValues.ISOBRev ?? 0,
        ...(isobData?.tab3?.pgCommercial && {
        OrderValueLakhs: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0),
        supplyType: isobData.tab3.pgCommercial.supplyType || "",
        serviceType: isobData.tab3.pgCommercial.serviceType || "",
        }),
        ...(isobData?.tab1?.isobBp && {
        Customercode: isobData.tab1.isobBp.find((bp) => bp.BPType === "Sold To")?.BPCode || "",
        Ship_to_code: isobData.tab1.isobBp.find((bp) => bp.BPType === "Ship To")?.BPCode || "",
        }),
        ...(commercialFiles.length && { CommercialAttachments: commercialFiles }),
        ...(technicalFiles.length && { TechnicalAttachments: technicalFiles }),
      };

      // 4. Add or Update OB record
      if (isEdit) {
        await updateOrderBookingData({ ID: formValues.ID, ...obChecklistFields });
        obUpdated = true; // flag so rollback knows to revert OB update
      } else {
        const obRes = await addOrderBookingData({
          ...obChecklistFields,
          ID: EnquiryID,
          SalesPersonId: salesperson.id || "",
          SiteCheckStatus: timelineRecordRef.current?.field_7 || null,
        });

        console.log("1. Inserting Order Booking...");
        orderBookingId = obRes.data.ID;

        insertedRecords.push({
          type: "orderBooking",
          id: orderBookingId,
          //rollback inserted record
          deleteFunction: () => rollbackOrderBooking(orderBookingId),
        });

        console.log(
          "Order Booking inserted successfully with ID:",
          orderBookingId,
        );
      }
      // 2. THEN: Insert all ISOB data if available tab 1
      if (isobData) {
        console.log("2. Starting ISOB data insertion...");
        const dirtyLists = new Set(isobData._dirtyLists || []);
        const arrayChanges = isobData._arrayChanges || {};
        const isNewRecord = !props.rowdata?.ID; // No existing OB = fresh insert for all

        // Helper: push an update rollback entry
        const trackUpdate = (type, recId, originalData) => {
          updatedRecords.push({ type, recId, originalData });
        };

        // 2a. Insert/Update main ISOB record
        if (isNewRecord) {
          const isobMainData = {
            ...isobData.tab1.isob,
            Scope1: isobData?.tab2.scope.scopeType,
            Scope_2: isobData?.tab2.scope.scopeText,
            Scope_3: isobData?.tab2.scope.partOrder,
            Title: String(orderBookingId),
          };
          const isobResponse = await addIsobData(isobMainData);
          insertedRecords.push({
            type: "isob",
            id: isobResponse.data.ID,
            //rolback inserted record isobResponse
            deleteFunction: () => rollbackIsobData("isob", isobResponse.data.ID),
          });
        } else if (dirtyLists.has("isob")) {
          trackUpdate("isob", isobData._recordIds?.isobId, isobData._snapshots?.isob);
          await updateIsob({
            type: "isob",
            Title: String(orderBookingId),
            isobRecId: isobData._recordIds?.isobId,
            data: {
              ...isobData.tab1.isob,
              Scope1: isobData?.tab2.scope.scopeType,
              Scope_2: isobData?.tab2.scope.scopeText,
              Scope_3: isobData?.tab2.scope.partOrder,
            },
          });
        }

        // 2b. Insert/Update ISOB Business Partners
        if (isNewRecord) {
          if (isobData.tab1.isobBp && isobData.tab1.isobBp.length > 0) {
            for (const bpRecord of isobData.tab1.isobBp) {
              const bpData = { ...bpRecord, Title: String(orderBookingId) };
              const bpResponse = await addIsobBpData(bpData);
              insertedRecords.push({
                type: "isobBp",
                id: bpResponse.data.ID,
                //rollback inserted isobBpResponse 
                deleteFunction: () => rollbackIsobData("isobBp", bpResponse.data.ID),
              });
            }
          }
        } else if (dirtyLists.has("isobBpSoldTo") || dirtyLists.has("isobBpShipTo")) {
          for (const bpRecord of isobData.tab1.isobBp) {
            const isSoldTo = bpRecord.BPType === "Sold To";
            if (isSoldTo && !dirtyLists.has("isobBpSoldTo")) continue;
            if (!isSoldTo && !dirtyLists.has("isobBpShipTo")) continue;
            const recId = isSoldTo ? isobData._recordIds?.soldToId : isobData._recordIds?.shipToId;
            const snapshotKey = isSoldTo ? "isobBpSoldTo" : "isobBpShipTo";
            trackUpdate("isobBp", recId, isobData._snapshots?.[snapshotKey]);
            await updateIsob({ type: "isobBp", Title: String(orderBookingId), isobRecId: recId, data: { ...bpRecord, Title: String(orderBookingId) } });
          }
        }

        // 2c. Insert/Update Components (array-based)
        if (isNewRecord || dirtyLists.has("comp")) {
          const compChanges = arrayChanges.comp || { added: [], updated: [], deleted: [] };
          console.log("compChanges", compChanges);
          console.log("isNewRecord", isNewRecord);
          console.log("dirtyLists.has(comp)", dirtyLists);


          if (isNewRecord) {
            // Fresh insert: add all
            for (const comp of (isobData.tab2.comp || [])) {
              const compData = {
                ProductGroup: comp?.productGroup,
                PGComponent: comp?.pgComponent,
                Color: comp?.color,
                APO_Color: comp?.apoStd,
                Title: String(orderBookingId),
              };
              const compResponse = await addIsobCompData(compData);
              insertedRecords.push({
                type: "comp",
                id: compResponse.data.ID,
                //rollback inserted comp response while adding any api fails
                deleteFunction: () => rollbackIsobData("comp", compResponse.data.ID),
              });
            }
          } else {
            // Incremental: only process added/updated/deleted
            for (const comp of compChanges.added) {
              const compData = {
                ProductGroup: comp?.productGroup,
                PGComponent: comp?.pgComponent,
                Color: comp?.color,
                APO_Color: comp?.apoStd,
                Title: String(orderBookingId),
              };
              const compResponse = await addIsobCompData(compData);
              insertedRecords.push({
                type: "comp",
                id: compResponse.data.ID,
                //rollback inserted record while updating isob api fails
                deleteFunction: () => rollbackIsobData("comp", compResponse.data.ID),
              });
            }
            for (const item of compChanges.updated) {
              trackUpdate("comp", item.originalData?.id, {
                ProductGroup: item.originalData?.productGroup,
                PGComponent: item.originalData?.pgComponent,
                Color: item.originalData?.color,
                APO_Color: item.originalData?.apoStd,
              });
              await updateIsob({
                type: "comp",
                Title: String(orderBookingId),
                isobRecId: item.originalData?.id,
                data: {
                  ProductGroup: item.data?.productGroup,
                  PGComponent: item.data?.pgComponent,
                  Color: item.data?.color,
                  APO_Color: item.data?.apoStd,
                },
              });
            }
            for (const item of compChanges.deleted) {
              //delete the item from sharepoint
              await rollbackIsobData("comp", item.data?.id);
              insertedRecords.push({
                type: "comp",
                id: item.data?.id,
             // if api fails then deleted record will insert again 
                deleteFunction: async () => {
                  await addIsobCompData({
                    ProductGroup: item.data?.productGroup,
                    PGComponent: item.data?.pgComponent,
                    Color: item.data?.color,
                    APO_Color: item.data?.apoStd,
                    Title: String(orderBookingId),
                  });
                },
              });
            }
          }
        }

        // 2d. Insert/Update Drawings (array-based)
        if (isNewRecord || dirtyLists.has("drw")) {
          const drwChanges = arrayChanges.drw || { added: [], updated: [], deleted: [] };
          if (isNewRecord) {
            for (const drw of (isobData.tab2.drw || [])) {
              const drwData = {
                DrawingNo: drw?.drawingNumber,
                DwgRevNo: drw?.revisionNumber,
                Title: String(orderBookingId),
              };
              const drwResponse = await addIsobDwgData(drwData);
              insertedRecords.push({
                type: "drw",
                id: drwResponse.data.d.ID,
                //if api fails while adding then rollback inserted record
                deleteFunction: () => rollbackIsobData("drw", drwResponse.data.d.ID),
              });
            }
          } else {
            for (const drw of drwChanges.added) {
              const drwData = {
                DrawingNo: drw?.drawingNumber,
                DwgRevNo: drw?.revisionNumber,
                Title: String(orderBookingId),
              };
              const drwResponse = await addIsobDwgData(drwData);
              insertedRecords.push({
                type: "drw",
                id: drwResponse.data.d.ID,
                //if api fails while updating then rollback inserted record
                deleteFunction: () => rollbackIsobData("drw", drwResponse.data.d.ID),
              });
            }
            for (const item of drwChanges.updated) {
              trackUpdate("drw", item.originalData?.id, {
                DrawingNo: item.originalData?.drawingNumber,
                DwgRevNo: item.originalData?.revisionNumber,
              });
              await updateIsob({
                type: "drw",
                Title: String(orderBookingId),
                isobRecId: item.originalData?.id,
                data: {
                  DrawingNo: item.data?.drawingNumber,
                  DwgRevNo: item.data?.revisionNumber,
                },
              });
            }
            for (const item of drwChanges.deleted) {
              //delete item from sharepoint
              await rollbackIsobData("drw", item.data?.id);
              insertedRecords.push({
                type: "drw",
                id: item.data?.id,
                //if any api fails then deleted record will insert again 
                deleteFunction: async () => {
                  await addIsobDwgData({
                    DrawingNo: item.data?.drawingNumber,
                    DwgRevNo: item.data?.revisionNumber,
                    Title: String(orderBookingId),
                  });
                },
              });
            }
          }
        }

        // 2e. Insert/Update PG Commercial (array-based)
        if (isNewRecord || dirtyLists.has("pgCommercial")) {
          const pgChanges = arrayChanges.pgCommercial || { added: [], updated: [], deleted: [] };
          if (isNewRecord) {
            for (const pgDetail of (isobData.tab3.pgCommercial.pgDetails || [])) {
              const pgData = {
                ProductGroup: pgDetail.solutionOffering,
                BOM_Price: parseFloat(pgDetail.bomPrice || 0.0),
                CustomerOrderPrice: parseFloat(pgDetail.cobp || 0.0),
                DealerOrderBasicPrice: parseFloat(pgDetail.dobp || 0.0),
                Overall_Outflow: parseFloat(isobData.tab3.pgCommercial.Overall_Outflow || 0.0),
                FinalBasicPrice: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0.0),
                Percentage_Discount_on_BOMPrice: parseFloat(pgDetail.discountOnBomPrice || 0.0),
                Dealer_Margin: parseFloat(pgDetail.dealerMargin || 0.0),
                Title: String(orderBookingId),
              };
              const pgResponse = await addIsobPgCommercialData(pgData);
              insertedRecords.push({
                type: "isobPgCommercial",
                id: pgResponse.data.ID,
                //rollback inserted record if any api fails
                deleteFunction: () => rollbackIsobData("isobPgCommercial", pgResponse.data.ID),
              });
            }
          } else {
            for (const pgDetail of pgChanges.added) {
              const pgData = {
                ProductGroup: pgDetail.solutionOffering,
                BOM_Price: parseFloat(pgDetail.bomPrice || 0.0),
                CustomerOrderPrice: parseFloat(pgDetail.cobp || 0.0),
                DealerOrderBasicPrice: parseFloat(pgDetail.dobp || 0.0),
                Overall_Outflow: parseFloat(isobData.tab3.pgCommercial.Overall_Outflow || 0.0),
                FinalBasicPrice: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0.0),
                Percentage_Discount_on_BOMPrice: parseFloat(pgDetail.discountOnBomPrice || 0.0),
                Dealer_Margin: parseFloat(pgDetail.dealerMargin || 0.0),
                Title: String(orderBookingId),
              };
              const pgResponse = await addIsobPgCommercialData(pgData);
              insertedRecords.push({
                type: "isobPgCommercial",
                id: pgResponse.data.ID,
                //rollback inserted record if any update api fails
                deleteFunction: () => rollbackIsobData("isobPgCommercial", pgResponse.data.ID),
              });
            }
            for (const item of pgChanges.updated) {
              trackUpdate("isobPgCommercial", item.originalData?.id, {
                ProductGroup: item.originalData?.solutionOffering,
                BOM_Price: parseFloat(item.originalData?.bomPrice || 0.0),
                CustomerOrderPrice: parseFloat(item.originalData?.cobp || 0.0),
                DealerOrderBasicPrice: parseFloat(item.originalData?.dobp || 0.0),
                Percentage_Discount_on_BOMPrice: parseFloat(item.originalData?.discountOnBomPrice || 0.0),
                Dealer_Margin: parseFloat(item.originalData?.dealerMargin || 0.0),
                Overall_Outflow: parseFloat(isobData.tab3.pgCommercial.Overall_Outflow || 0.0),
                FinalBasicPrice: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0.0),  
              });
              await updateIsob({
                type: "isobPgCommercial",
                Title: String(orderBookingId),
                isobRecId: item.originalData?.id,
                data: {
                  ProductGroup: item.data.solutionOffering,
                  BOM_Price: parseFloat(item.data.bomPrice || 0.0),
                  CustomerOrderPrice: parseFloat(item.data.cobp || 0.0),
                  DealerOrderBasicPrice: parseFloat(item.data.dobp || 0.0),
                  Percentage_Discount_on_BOMPrice: parseFloat(item.data.discountOnBomPrice || 0.0),
                  Dealer_Margin: parseFloat(item.data.dealerMargin || 0.0),
                  Overall_Outflow: parseFloat(isobData.tab3.pgCommercial.Overall_Outflow || 0.0),
                  FinalBasicPrice: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0.0),
                },
              });
            }
            for (const item of pgChanges.deleted) {
              //delete the item from sharepoint
              await rollbackIsobData("isobPgCommercial", item.data?.id);
              insertedRecords.push({
                type: "isobPgCommercial",
                id: item.data?.id,
                //if api fails then deleted record will insert again
                deleteFunction: async () => {
                  await addIsobPgCommercialData({
                    ProductGroup: item.data?.solutionOffering,
                    BOM_Price: parseFloat(item.data?.bomPrice || 0.0),
                    CustomerOrderPrice: parseFloat(item.data?.cobp || 0.0),
                    DealerOrderBasicPrice: parseFloat(item.data?.dobp || 0.0),
                    Percentage_Discount_on_BOMPrice: parseFloat(item.data?.discountOnBomPrice || 0.0),
                    Dealer_Margin: parseFloat(item.data?.dealerMargin || 0.0),
                    Overall_Outflow: parseFloat(isobData.tab3.pgCommercial.Overall_Outflow || 0.0),
                    FinalBasicPrice: parseFloat(isobData.tab3.pgCommercial.FinalBasicPrice || 0.0),
                    Title: String(orderBookingId),
                  });
                },
              });
            }
          }
        }

        // 2f. Insert/Update LD Details
        if (isNewRecord) {
          const ldData = { Title: String(orderBookingId), ...isobData.tab3.ldDetails };
          const ldResponse = await addIsobLdData(ldData);
          insertedRecords.push({
            type: "isobLd",
            id: ldResponse.data.ID,
            //rollback inserted record while adding any api fails
            deleteFunction: () => rollbackIsobData("isobLd", ldResponse.data.ID),
          });
        } else if (dirtyLists.has("ld")) {
          trackUpdate("isobLd", isobData._recordIds?.ldId, isobData._snapshots?.isobLd);
          await updateIsob({
            type: "isobLd",
            Title: String(orderBookingId),
            isobRecId: isobData._recordIds?.ldId,
            data: isobData.tab3.ldDetails,
          });
        }

        // 2g. Insert/Update Dealer SAC
        if (isNewRecord) {
          const dealerSacData = { Title: String(orderBookingId), ...isobData.tab3.dealerSac };
          const dealerSacResponse = await addIsobDealerSacData(dealerSacData);
          insertedRecords.push({
            type: "isobDealerSac",
            id: dealerSacResponse.data.ID,
            //rollback record if any api fail while updating
            deleteFunction: () => rollbackIsobData("isobDealerSac", dealerSacResponse.data.ID),
          });
        } else if (dirtyLists.has("dealerSac")) {
          trackUpdate("isobDealerSac", isobData._recordIds?.sacId, isobData._snapshots?.isobDealerSac);
          await updateIsob({
            type: "isobDealerSac",
            Title: String(orderBookingId),
            isobRecId: isobData._recordIds?.sacId,
            data: isobData.tab3.dealerSac,
          });
        }

        // 2h. Insert/Update Advance
        if (isNewRecord) {
          const advanceData = { Title: String(orderBookingId), ...isobData.tab3.advance };
          const advanceResponse = await addIsobAdvanceData(advanceData);
          insertedRecords.push({
            type: "isobAdvance",
            id: advanceResponse.data.ID,
            //rollback if any api fails while updating
            deleteFunction: () => rollbackIsobData("isobAdvance", advanceResponse.data.ID),
          });
        } else if (dirtyLists.has("advance")) {
          trackUpdate("isobAdvance", isobData._recordIds?.advId, isobData._snapshots?.isobAdvance);
          await updateIsob({
            type: "isobAdvance",
            Title: String(orderBookingId),
            isobRecId: isobData._recordIds?.advId,
            data: isobData.tab3.advance,
          });
        }

        // 2i. Insert/Update Misc
        if (isNewRecord) {
          const miscData = { ...isobData.tab4.misc, Title: String(orderBookingId) };
          const miscResponse = await addIsobMiscData(miscData);
          const miscId = miscResponse.data.d.ID;
          insertedRecords.push({
            type: "isobMisc",
            id: miscId,
            deleteFunction: () => rollbackIsobData("isobMisc", miscId),
          });
        } else if (dirtyLists.has("misc")) {
          trackUpdate("isobMisc", isobData._recordIds?.miscId, isobData._snapshots?.isobMisc);
          await updateIsob({
            type: "isobMisc",
            Title: String(orderBookingId),
            isobRecId: isobData._recordIds?.miscId,
            data: isobData.tab4.misc,
          });
        }
      }
      Alert("success", "Order Booking and ISOB submitted successfully");
      setIsobData(null);
      setIsobFormValues({});
      setNewRemark("");
      handleClose();
    } catch (error) {
      console.error("Error in submission:", error);

      // Rollback all inserted ISOB records (and OB record if Add mode) in reverse
      for (let i = insertedRecords.length - 1; i >= 0; i--) {
        try { await insertedRecords[i].deleteFunction(); }
        catch (e) { console.error(`Rollback failed for ${insertedRecords[i].type}:`, e); }
      }
      const rollbackObId = orderBookingId;
      for (let i = updatedRecords.length - 1; i >= 0; i--) {
        const { type, recId, originalData } = updatedRecords[i];
        if (!recId || !originalData) { console.warn(`Skipping restore for ${type}: missing recId or snapshot`); continue; }
        try { await updateIsob({ type, Title: String(rollbackObId), isobRecId: recId, data: originalData }); }
        catch (e) { console.error(`Restore failed for ${type}:`, e); }
      }
      // Rollback OB update in Edit mode by restoring the snapshot
      if (isEdit && obUpdated && editSnapshot) {
        try {
          await updateOrderBookingData({ ID: formValues.ID, ...editSnapshot });
        } catch (e) {
          console.error("Failed to rollback OB update:", e);
        }
      }

      Alert("error", "Failed to submit. All changes have been rolled back.");
    } finally {
      setLoading(false);
    }
  };


  console.log("formvalues in orderbboking for pdf", props.rowdata);
  const handleDownloadPdf = async () => {
    setLoading(true);
    try {
      const obRecord = props.rowdata || formValues;
      const payload = {
        ID: obRecord.ID,
        Title: obRecord.Title,
        Branch: obRecord.Branch,
        CustomerName: obRecord.CustomerName,
        Approvalstatus: obRecord.Approvalstatus,
        CustomerType: obRecord.CustomerType,
        OrderType: obRecord.OrderType,
        PG: obRecord.PG?.results || obRecord.PG,
        OrderValueLakhs: obRecord.OrderValueLakhs,
        Sitelocation: obRecord.Sitelocation,
        Routing: obRecord.Routing,
        ChannelType: obRecord.ChannelType,
        ScopeOfInstallation: obRecord.ScopeOfInstallation,
        Plant: obRecord.Plant,
        OrderBookingType: obRecord.OrderBookingType,
        Government: obRecord.Government,
        Customercode: obRecord.Customercode,
        Ship_to_code: obRecord.Ship_to_code,
        Supply_type: obRecord.Supply_type,
        Service_type: obRecord.Service_type,
        Service_Category: obRecord.Service_Category,
        Dom_Exp: obRecord.Dom_Exp,
        SubmittedTime: obRecord.SubmittedTime,
        ProjectReferenceNumber: obRecord.ProjectReferenceNumber,
        remarks: obRecord.remarks,
        ISOB: obRecord.ISOB,
        DrawingApprovalMail: obRecord.DrawingApprovalMail,
        FinalDirectBookingBOM: obRecord.FinalDirectBookingBOM,
        LOICustConfirmation: obRecord.LOICustConfirmation,
        CustomerPO: obRecord.CustomerPO,
        DealerPO: obRecord.DealerPO,
        DrawingLayout: obRecord.DrawingLayout,
        PreOrderTimeline: obRecord.PreOrderTimeline,
        DiscountSanction: obRecord.DiscountSanction,
        SiteChecklist: obRecord.SiteChecklist,
        SiteMeasurements: obRecord.SiteMeasurements,
        DeliveryGSTAddressProof: obRecord.DeliveryGSTAddressProof,
        TDSDeclaration: obRecord.TDSDeclaration,
        PhyMaterialConfirmation: obRecord.PhyMaterialConfirmation,
        AdvanceReceipt: obRecord.AdvanceReceipt,
        AdditionalDocs: obRecord.AdditionalDocs,
      };
      await downloadOrderBookingPdf(payload);
    } catch (err) {
      Alert("error", "Failed to generate PDF");
    } finally {
      setLoading(false);
    }
  };


  const handleShowIsob = () => {
    // Alert("error", "ISOB session is under development.");
    setShowIsob(true)
  };

  const handleEditOrderBooking = () => {
    setEditSnapshot({ ...formValues });
    setAction("Edit");
  };

  const handleDownloadIsobPdf = async () => {
    setLoading(true);
    try {
      const obRecord = props.rowdata || formValues;
      const payload = {
        ID: obRecord.ID,
        Title: obRecord.Title,
        Branch: obRecord.Branch,
        CustomerName: obRecord.CustomerName,
        Approvalstatus: obRecord.Approvalstatus,
        CustomerType: obRecord.CustomerType,
        OrderType: obRecord.OrderType,
        PG: obRecord.PG?.results || obRecord.PG,
        OrderValueLakhs: obRecord.OrderValueLakhs,
        Sitelocation: obRecord.Sitelocation,
        Routing: obRecord.Routing,
        ChannelType: obRecord.ChannelType,
        ScopeOfInstallation: obRecord.ScopeOfInstallation,
        Plant: obRecord.Plant,
        OrderBookingType: obRecord.OrderBookingType,
        Government: obRecord.Government,
        Customercode: obRecord.Customercode,
        Ship_to_code: obRecord.Ship_to_code,
        Supply_type: obRecord.Supply_type,
        Service_type: obRecord.Service_type,
        Service_Category: obRecord.Service_Category,
        Dom_Exp: obRecord.Dom_Exp,
        SubmittedTime: obRecord.SubmittedTime,
        ProjectReferenceNumber: obRecord.ProjectReferenceNumber,
        remarks: obRecord.remarks,
      };

      const response = await downloadOrderBookingPdf(payload);
      const d = response || {};
      const ob = d.obData || {};
      const isob = (d.isob || [])[0] || {};
      const soldTo = (d.bpSoldToData || [])[0] || {};
      const shipTo = (d.bpShipToData || [])[0] || {};
      const comps = (d.pgCompData || []).map(c => ({ productGroup: c.ProductGroup || "", pgComponent: c.PGComponent || "", apoStd: c.APO_Color === true ? "Standard" : c.APO_Color === false ? "APO" : (c.APO_Color || ""), color: c.Color || "" }));
      const dwgs = (d.dwgData || []).map(dw => ({ drawingNumber: dw.DrawingNo || "", revisionNumber: dw.DwgRevNo || "" }));
      const pgComm = d.pgCommercialData || [];
      const pgDetails = pgComm.map(p => ({
        solutionOffering: p.ProductGroup || "",
        bomPrice: String(p.BOM_Price || ""),
        discountOnBomPrice: String(p.Percentage_Discount_on_BOMPrice || ""),
        cobp: String(p.CustomerOrderPrice || ""),
        dealerMargin: String(p.Dealer_Margin || ""),
        dobp: String(p.DealerOrderBasicPrice || ""),
      }));
      const sac = (d.dealerSacData || [])[0] || {};
      const adv = (d.advanceData || [])[0] || {};
      const ld = (d.ldData || [])[0] || {};
      const misc = (d.miscData || [])[0] || {};
      const timelineRec = d.timelineData || {};
      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const dt = new Date(dateStr);
        if (isNaN(dt)) return dateStr;
        return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
      };

      const commSummary = d.commercialSummaryData || {};
      const finalBasicPrice = pgComm[0]?.FinalBasicPrice || "";
      const overallOutflow = pgComm[0]?.Overall_Outflow ? pgComm[0]?.Overall_Outflow + "%" : "";
      const advPercent = adv.Advance || 0;
      const delPercent = adv.Adv_Delivery || 0;
      const instPercent = adv.Adv_Instalaltion || 0;
      const orderVal = parseFloat(finalBasicPrice) || 0;
      const advValue = orderVal ? String(Math.round(orderVal * advPercent)) : "";
      const delValue = orderVal ? String(Math.round(orderVal * delPercent)) : "";
      const instValue = orderVal ? String(Math.round(orderVal * instPercent)) : "";
      const totalPercent = advPercent + delPercent + instPercent;
      const totalValue = orderVal ? String(Math.round(orderVal * totalPercent)) : "";

      generateIsobPdf({
        // Section 1 - Order Summary
        enquiryNo: ob.Title || "",
        customerName: ob.CustomerName || "",
        revNo: isob.RevNo || "0.0",
        Branch: ob.Branch || "",
        PG: Array.isArray(ob.PG) ? ob.PG.join(", ") : (ob.PG || ""),
        OrderValueLakhs: finalBasicPrice ? String(finalBasicPrice) : String(ob.OrderValueLakhs || ""),
        Routing: ob.Routing || "",
        CustomerType: ob.CustomerType || "",
        ChannelType: ob.ChannelType || "",
        OrderType: ob.OrderType || "",
        ScopeOfInstallation: ob.ScopeOfInstallation || "",
        CommercialApproval: ob.Approvalstatus || "",
        PODate: formatDate(isob.PODate),
        LDDate: formatDate(ld.Delivery_enddate),
        DAPDate: formatDate(isob.TechApprovalDate),
        SiteReadiness: misc.Site_readiness ? "Yes" : "No",

        // Sold To
        BPCode: soldTo.BPCode || "",
        BPName: soldTo.BPName || "",
        BPGSTN: soldTo.BPGSTN || "",
        CIN: soldTo.CIN || "",
        BPTAN: soldTo.TAN || "",
        Location: soldTo.Location || "",
        Pincode: soldTo.Pincode != null ? String(soldTo.Pincode) : "",
        BPAddress: soldTo.BPAddress || "",
        ContactName: soldTo.ContactName || "",
        Mobile: soldTo.ContactMobile != null ? String(soldTo.ContactMobile) : "",
        Email: soldTo.ContactEmail || "",
        Designation: soldTo.ContactDesignation || "",
        AddressCode: soldTo.AddressCode || "",

        // Ship To
        Ship_BPCode: shipTo.BPCode || "",
        Ship_BPName: shipTo.BPName || "",
        Ship_BPGSTN: shipTo.BPGSTN || "",
        Ship_CIN: shipTo.CIN || "",
        Ship_BPTAN: shipTo.TAN || "",
        Ship_Location: shipTo.Location || "",
        Ship_Pincode: shipTo.Pincode != null ? String(shipTo.Pincode) : "",
        Ship_BPAddress: shipTo.BPAddress || "",
        Ship_ContactName: shipTo.ContactName || "",
        Ship_Mobile: shipTo.ContactMobile != null ? String(shipTo.ContactMobile) : "",
        Ship_Email: shipTo.ContactEmail || "",
        Ship_Designation: shipTo.ContactDesignation || "",
        Ship_AddressCode: shipTo.AddressCode || "",

        // Other Details
        PO_number: isob.POnumber || "",
        Segment: soldTo.Segment || "",
        WHType: isob.Application || "",
        SKU_stored: isob.SKU_stored || "",
        BOM_type: isob.BOM_type || "",
        DocumentExchangePlace: isob.DocumentExchangePlace || "",
        RelatedToPastSupply: isob.Past_supply || "",
        PastSONo: isob.Past_supply === "Yes" ? (isob.SO_number || "-") : "-",
        DesignEnqNo: dwgs.length > 0 ? dwgs[dwgs.length - 1].drawingNumber : "",
        DrawingRevisionNumber: dwgs.length > 0 ? dwgs[dwgs.length - 1].revisionNumber : "",
        SalespersonName: timelineRec.SalesManagerId || "",
        SalespersonEmail: timelineRec.SalesManagerEmail || "",
        Emp_Scode: isob.Emp_Scode || "",
        Emp_Mobile: isob.Emp_Mobile || "",

        // Section 2 - Components & Drawings
        apoStandard: comps[0]?.apoStd || "",
        components: comps,
        drawings: dwgs,
        scopeType: isob.Scope1 || "",
        scopeText: isob.Scope_2 || "",
        partOrder: isob.Scope_3 || "",

        // Section 3 - Commercial
        pgDetails,
        FinalBasicPrice: String(finalBasicPrice),
        Overall_Outflow: String(overallOutflow),
        discountOnCOBP: commSummary.discountOnCOBP ? commSummary.discountOnCOBP + "%" : "",
        customerOrderBasicPrice: commSummary.customerOrderBasicPrice || "",
        dealerMarginPercent: commSummary.dealerMarginPercent ? commSummary.dealerMarginPercent + "%" : "",
        dealerOrderBasicPrice: commSummary.dealerOrderBasicPrice || "",
        supplyType: pgComm[0]?.supplyType || ob.Supply_type || "",
        supplyTax: commSummary.supplyTax || "",
        serviceType: pgComm[0]?.serviceType || ob.Service_type || "",
        serviceTax: commSummary.serviceTax || "",
        priceAfterTax: commSummary.priceAfterTax || "",

        // Payment Terms
        Advance: adv.Advance ? String(adv.Advance) : "",
        againstDeliveryPercent: adv.Adv_Delivery ? String(adv.Adv_Delivery) : "",
        againstInstallationPercent: adv.Adv_Instalaltion ? String(adv.Adv_Instalaltion) : "",
        advanceValue: advValue,
        againstDeliveryValue: delValue,
        againstInstallationValue: instValue,
        totalPercent: totalPercent ? `${Math.round(totalPercent * 100)} %` : "",
        totalValue: totalValue,
        installationCharge: adv.Installation_charge ? String(adv.Installation_charge) : "",

        // Dealer SAC
        DealerSAC_applicable: sac.DealerSAC_applicable || "No",
        Dealer_SAC: sac.Dealer_SAC ? String(sac.Dealer_SAC) : "",
        DealerSAC_value: sac.DealerSAC_value ? String(sac.DealerSAC_value) : "",
        DealerCode: sac.DealerCode || "",
        enquiryGeneration: sac.Enq_gen ? "Yes" : "No",
        orderClosing: sac.Order_closing ? "Yes" : "No",
        paymentCollection: sac.Payment_collection ? "Yes" : "No",
        installation: sac.Installation ? "Yes" : "No",
        creditSharing: sac.Credit_sharing ? "Yes" : "No",
        creditSharingBranch: sac.Sharing_Branch || "",
        creditSharingValue: sac.Sharing_value ? String(sac.Sharing_value) : "",
        creditSharingSMId: sac.SMId ? String(sac.SMId) : "",

        // LD
        LD_applicable: ld.LD_applicable || "No",
        LD_Delivery_startdate: formatDate(ld.Delivery_startdate),
        LD_Delivery_enddate: formatDate(ld.Delivery_enddate),
        LD_Delivery_LD_per_week: ld.Delivery_LD_per_week ? String(ld.Delivery_LD_per_week) : "",
        LD_Delivery_max_LD: ld.Delivery_max_LD ? String(ld.Delivery_max_LD) : "",
        LD_min: ld.LD_min ? String(ld.LD_min) : "",
        LD_max: ld.LD_max ? String(ld.LD_max) : "",
        LD_Instal_startdate: formatDate(ld.Instal_startdate),
        LD_Instal_enddate: formatDate(ld.Instal_enddate),
        LD_Instal_LD_per_week: ld.Instal_LD_per_week ? String(ld.Instal_LD_per_week) : "",
        LD_Instal_max_LD: ld.Instal_max_LD ? String(ld.Instal_max_LD) : "",

        // Section 4 - Projects Supply & Installation
        inspectionReqd: misc.Inspection_reqd || "",
        inspectionAt: misc.Inspection_at || "",
        inspectionAgency: misc.Inspection_agency || "",
        inspContactName: misc.Contact_name || "",
        inspContactMobile: misc.Contact_mobile || "",
        inspContactAddress: misc.Contact_address || "",
        supplyRemarks: misc.Supply_Remarks || "",
        siteContactPerson: misc.Site_Contact_Person || "",
        siteContactMobile: misc.Site_Contact_Mobile != null ? misc.Site_Contact_Mobile?.toString() : "",
        logisticsRemarks: misc.Logistics_Remarks || "",
        miscQap: misc.QAP ? "Yes" : "No",
        miscLoadTest: misc.Load_test ? "Yes" : "No",
        processCheckingVisitToFactory: misc.Process_check || "",
        miscSiteDimension: misc.Site_dimension ? "Yes" : "No",
        miscSiteReadiness: misc.Site_readiness ? "Yes" : "No",
        miscVisualInspection: misc.Visual_inspection ? "Yes" : "No",
        miscInstallationBy: misc.Installation || "",
        scopeOfPowerSupply: misc.Power_supply || "",
        miscExistingRacks: misc.Exisitng_racks ? "Yes" : "No",
        scopeOfExistingRacksRemoval: misc.Existing_racks_scope || "",
        miscWorkingWarehouse: misc.Working_warehouse ? "Yes" : "No",
        scopeOfUnloading: misc.Unloading || "",
        miscMultipleFloors: misc.Multiple_floors ? "Yes" : "No",
        multipleFloorDetails: misc.Multiple_floors_details || "",
        miscCoveredSpace: misc.Covered_space ? "Yes" : "No",
        miscInstallationRemarks: misc.Installation_remarks || "",

        // Section 5 - Timelines
        preOrderDesignStart: formatDate(timelineRec.field_18),
        preOrderDesignFinish: formatDate(timelineRec.field_19),
        preOrderSupplyStart: formatDate(timelineRec.field_21),
        preOrderSupplyFinish: formatDate(timelineRec.field_22),
        preOrderInstallStart: formatDate(timelineRec.field_24),
        preOrderInstallFinish: formatDate(timelineRec.field_25),
        zeroDate: formatDate(timelineRec.field_8),
        supplyDesignStart: "",
        supplyDesignFinish: "",
        supplySupplyStart: "",
        supplySupplyFinish: "",
        supplyInstallStart: "",
        supplyInstallFinish: "",
        timelineRemarks: "",
        OtherInformation: isob.Other_Info || "",
      });
    } catch (err) {
      console.error("Error generating ISOB PDF:", err);
      Alert("error", "Failed to generate ISOB PDF");
    } finally {
      setLoading(false);
    }
  };

  const handleIsobOnBack = (isobStructuredData, rawFormValues) => {
    if (isobStructuredData) {
      setIsobData(isobStructuredData);
      setIsobFormValues(rawFormValues);
      // Update formValues with ISOB status
     setFormValues((prev) => {
            const currentRev = prev.ISOBRev ?? 0;
            const isEdit = isobStructuredData._isEdit;
            const newRev = isEdit ? currentRev + 1 : (currentRev === 0 ? 1 : currentRev);
            return { ...prev, ISOB: "Attached", ISOBRev: newRev, OrderValueLakhs: parseFloat(isobStructuredData.tab3?.pgCommercial?.FinalBasicPrice || prev.OrderValueLakhs || 0)};
        });
    }
    setShowIsob(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // useEffect(() => {
  //     setLoading(true)
  //     setTimeout(() => {
  //         setLoading(false)
  //     }, 1000);
  // }, []);

  console.log("!!(props.rowdata?.ProjectReferenceNo)", !!(props.rowdata?.ProjectReferenceNo));

  return (
    <>
      {loading && (
        <div className="loader-box">
          {" "}
          <img src={Loader} alt="Loading" className="newloader"></img>{" "}
        </div>
      )}
      {show && (
        <ConfirmAlertModal
          action={action}
          handleYes={handleAdd}
          formName={formName}
          show={show}
          handleClose={handleCloseConf}
        />
      )}
      {showWarning && (
        <WariningAlertModal
          action={action}
          handleYes={props.onHide}
          formName={formName}
          show={showWarning}
          handleClose={handleCloseWarningConf}
          waringMessage={waringMessage}
        />
      )}
      {showDiscountAdd && (
        <DiscountAdd
          show={showDiscountAdd}
          onHide={handleDiscountClose}
          enquiryData={formValues}
          EnquiryID={EnquiryID}
          hideForm={props.onHide}
        />
      )}
      {showTimelineMaster && (
        <AddTimelineMaster
          show={showTimelineMaster}
          onHide={() => setShowTimelineMaster(false)}
          enquiryData={formValues}
          action={"Add"}
          onTimelineSuccess={() => {
            setShowTimelineMaster(false);
            props.onHide();
          }}
        />
      )}
      {showTimelineView && timelineRecord && (
        <AddTimelineMaster
          show={showTimelineView}
          onHide={() => setShowTimelineView(false)}
          rowdata={timelineRecord}
          action={"View"}
        />
      )}
      {showDiscountView && discountRecord && (
        <DiscountAdd
          show={showDiscountView}
          onHide={() => setShowDiscountView(false)}
          rowdata={discountRecord}
          EnquiryID={EnquiryID}
          action={"View"}
          hideForm={() => { }}
        />
      )}

      {showAmendment ? (
        <AmendmentHistory
          formValues={formValues}
          enquiryData={props.enquiryData}
          isobData={isobData}
          onBack={() => setShowAmendment(false)}
        />
      ) : showIsob ? (
        <AddIsob
          orderBookingFormData={formValues}
          initialFormValues={isobFormValues}
          enquiryData={props.enquiryData}
          action={action}
          discountRecord={discountRecord}
          // onBack={() => setShowIsob(false)}
          onBack={handleIsobOnBack}
        />
      ) : (
        <div className="add-order-booking-container">
          <div className="ob-details-header">
            <h4 className="ob-details-title">Order booking details</h4>
            {
              (action === "View") &&
              <div className="ob-header-actions">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip className="custom-tooltip">
                      Edit Order Booking
                    </Tooltip>
                  }
                >
                  <img
                    src={editIcon}
                    alt="ISOB"
                    onClick={handleEditOrderBooking}
                    className="ob-edit-icon"
                  />
                </OverlayTrigger>
                {showIsobPdfIcon && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip className="custom-tooltip">
                      Download ISOB PDF
                    </Tooltip>
                  }
                >
                  <img
                    src={pdfIcon}
                    alt="Download ISOB PDF"
                    onClick={handleDownloadIsobPdf}
                    className="ob-download-icon"
                  />
                </OverlayTrigger>
                )}
              </div>
            }
          </div>
          <div className="scrollForm orderbooking">
            <div className="ob-details-card">
              <div className="ob-details-item">
                <div className="ob-details-icon">
                  <img src={BuildingIcon} alt="Customer" />
                </div>
                <div className="ob-details-text">
                  <span className="ob-details-label">Customer</span>
                  <span className="ob-details-value">
                    {props.enquiryData?.AccountName ||
                      props.rowdata?.CustomerName ||
                      "--"}
                  </span>
                </div>
              </div>
              <div className="ob-details-divider"></div>
              <div className="ob-details-item">
                <div className="ob-details-icon">
                  <img src={DocSearchIcon} alt="Enquiry" />
                </div>
                <div className="ob-details-text">
                  <span className="ob-details-label">Enquiry No.</span>
                  <span className="ob-details-value">
                    {props.enquiryData?.ID || props.rowdata?.Title || "--"}
                  </span>
                </div>
              </div>
              <div className="ob-details-divider"></div>
              <div className="ob-details-item">
                <div className="ob-details-icon">
                  <img src={SettingNoteIcon} alt="Project" />
                </div>
                <div className="ob-details-text">
                  <span className="ob-details-label">
                    Project Reference No.
                  </span>
                  <span className="ob-details-value">
                    {
                      props.rowdata?.ID ||
                      "--"}
                  </span>
                </div>
              </div>
              <div className="ob-details-item ob-details-order-value">
                <div className="ob-details-text">
                  <span className="ob-details-label">Order Value (INR)</span>
                  <span className="ob-details-value ob-value-inr">
                    ₹{" "}
                    {isobData?.tab3?.pgCommercial?.FinalBasicPrice
                      ? validINRCurrency(isobData?.tab3?.pgCommercial?.FinalBasicPrice)
                      : formValues?.OrderValueLakhs ? validINRCurrency(formValues.OrderValueLakhs) : ""}
                  </span>
                  <span className="ob-value-lacs">
                    {formatAmountLabel(isobData?.tab3?.pgCommercial?.FinalBasicPrice || formValues?.OrderValueLakhs)}
                  </span>
                </div>
              </div>
            </div>
            <Form>
              <OrderBookingTab
                action={action}
                formValues={formValues}
                handleInputChange={handleInputChange}
                errors={errors}
                setErrors={setErrors}
                mandatoryFields={mandatoryFields}
                setMandatoryFields={setMandatoryFields}
                getDropDownOptions={getDropDownOptions}
                fileNames={fileNames}
                handleFileDownload={handleFileDownload}
                obj={obj}
                file={file}
                handleChangeStatus={handleChangeStatus}
                handleDeleteDocument={handleDeleteDocument}
                commonFileUploadProps={commonFileUploadProps}
                commonProps={commonProps}
                onEditIsob={handleShowIsob}
                onDownloadIsob={() => { }}
                isobRevisionCount={formValues.ISOBRev ?? 0}
                timelineRecord={timelineRecord}
                discountRecord={discountRecord}
                reasonForSubmissionMapping={reasonForSubmissionMapping}
                isTechnicalReadOnly={action === "Edit" && !!(props.rowdata?.ProjectReferenceNo)}
                onDeletedOldFilesChange={(files) => setDeletedOldFiles(files)}
                resetKey={resetKey}
                onLoadingChange={(isLoading) => setLoading(isLoading)}
                newRemark={newRemark}
                onNewRemarkChange={(val) => setNewRemark(val)}
                showAmendmentIcon={
                  (action === "View" || action === "Edit") &&
                  (formValues.OrderBookingType?.toLowerCase().includes("revision: technical change") ||
                    amendmentData.length > 0)
                }
                onOpenAmendment={() => setShowAmendment(true)}
                onViewTimeline={() => {
                  if (timelineRecordRef.current?.Title) {
                    setShowTimelineView(true);
                  } else {
                    Alert(
                      "error",
                      "Pre Order Timeline record does not exist for this Enquiry",
                    );
                  }
                }}
                onViewDiscount={() => {
                  if (discountRecordRef.current?.field_5) {
                    setShowDiscountView(true);
                  } else {
                    Alert(
                      "error",
                      "Discount Sanction record does not exist for this Enquiry",
                    );
                  }
                }}
              />

              <div className="add-order-booking-footer">
                <div className="ob-footer-left">
                  <Button
                    bsPrefix="reset-btn"
                    className="reset-btn-primary"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </div>
                <div className="ob-footer-right">
                  <Button
                    bsPrefix="reset-btn"
                    className="reset-btn-primary"
                    onClick={resetForm}
                    disabled={action === "View"}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="primary"
                    className="modal-btn-sub"
                    onClick={handleAdd}
                    disabled={
                      action === "View" ||
                      !isFormValid ||
                      loading ||
                      mandatoryFields.length > 0 ||
                      Object.values(errors).some(v => v && v !== "")
                    }
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
    </>
  );
}
